import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Grid, Navigation, Pagination } from "swiper";
import BtnArrow from "../images/btn_arrow.svg";
import HashtagIconFb from "../images/hashtag_icon_fb.svg";
import HashtagIconIg from "../images/hashtag_icon_ig.svg";
import { shuffleData } from "../utils/common";
import staticData from "../generated/staticData";
import { trackEvent } from "../utils/analytics";

const hashtagSnapshot = staticData || {};

const Hashtag = () => {
    const [postData] = useState(hashtagSnapshot.hashtagWall || []);
    const screenWidth = useRef(window.innerWidth).current;
    const swiperOptions = {
        spaceBetween: screenWidth > 767 ? 14 : 10,
        navigation: screenWidth > 767 ? true : false
    };

    // 埋設 GA 點擊徵文抽獎去按鈕傳送參數
    const sendGaEventTopic = () => {
        trackEvent("event", "Click", {
            "event_category": "Sheet",
            "event_label": "sheettopic_click",
            "value": 1
        });
    };

    // 埋設 GA 點擊 FB.IG 按鈕傳送參數
    const sendGaEventSocial = (e) => {
        trackEvent("event", "Click", {
            "event_category": "Sheet",
            "event_label": e.currentTarget.dataset.label,
            "value": 1
        });
    };

    return (
        <section
            id="hashtag"
            className="hashtag"
            data-aos="fade-in"
            data-aos-easing="linear"
            data-aos-duration="1000"
        >
            <h2 className="title">
                全民踩點來卡Way!
            </h2>
            <div className="description">
                <h3># 潮Way台南最有台南味</h3>
                <div className="social-media">
                    <a
                        href="https://www.facebook.com/hashtag/2023%E6%BD%AEway%E5%8F%B0%E5%8D%97%E6%9C%80%E6%9C%89%E5%8F%B0%E5%8D%97%E5%91%B3"
                        className="icon-fb"
                        target="_blank"
                        onClick={sendGaEventSocial}
                        data-label="sheetFB_click"
                        rel="noreferrer"
                    >
                        <img src={HashtagIconFb} width={20} height={34} alt="icon-fb" />
                    </a>
                    <a
                        href="https://www.instagram.com/explore/tags/2023%E6%BD%AEway%E5%8F%B0%E5%8D%97%E6%9C%80%E6%9C%89%E5%8F%B0%E5%8D%97%E5%91%B3/"
                        className="icon-ig"
                        target="_blank"
                        onClick={sendGaEventSocial}
                        data-label="sheetIG_click"
                        rel="noreferrer"
                    >
                        <img src={HashtagIconIg} width={28} height={28} alt="icon-ig" />
                    </a>
                </div>
                <p>
                    在台南這樣拍才正港！全民都是潮旅玩家！<br />
                    快來分享你與台南間的回憶！<br />
                    只要在台南打卡發布公開貼文標記指定#Hashtag<br />
                    就有機會抽中多項大獎好禮！
                </p>
                <div className="link-btn">
                    <a
                        href="https://topic.events.pixnet.net/activity/908"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span>活動辦法</span>
                        <img src={BtnArrow} width={12} height={19} alt="btn-arrow" />
                    </a>
                    <a
                        href="https://topic.events.pixnet.net/submit/908"
                        target="_blank"
                        onClick={sendGaEventTopic}
                        rel="noreferrer"
                    >
                        <span>打卡抽獎去</span>
                        <img src={BtnArrow} width={12} height={19} alt="btn-arrow" />
                    </a>
                    <a
                        href="https://eventblog.pixnet.net/blog/post/70561854"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span>得獎名單</span>
                        <img src={BtnArrow} width={12} height={19} alt="btn-arrow" />
                    </a>
                </div>
                <div className="photo-slider container">
                    <Swiper
                        modules={[Autoplay, Grid, Navigation, Pagination]}
                        slidesPerView={3}
                        slidesPerGroup={3}
                        spaceBetween={swiperOptions.spaceBetween}
                        navigation={swiperOptions.navigation}
                        pagination={{ clickable: true }}
                        autoplay={{ delay: 5000 }}
                        grid={{
                            rows: 3,
                            fill: "row"
                        }}
                    >
                        {
                            postData && shuffleData(postData).slice(0, 27).map((item, i) => (
                                <SwiperSlide key={item.title + i} className="item">
                                    <a href={item.link} target="_blank" rel="noreferrer">
                                        <img src={item.image} width={250} height={250} alt="hashtag-photo" />
                                    </a>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Hashtag;
